<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        03.02
        <br>2020
      </span>
      <span class="tiel">武汉蔬菜便民快车来了！美菜联手公交集团为市民保供</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        <p>“试运行了一天，效果很好，配送量大大增加。”美菜商城江夏六仓美鲜送经理甘承志说，一辆公交车能装下4条线的菜，公司配送压力得到缓解。</p>
        <br>
        <p>疫情发生以来，电商平台下单、小区配送、无接触取货成为武汉市民生活物资保障的主要方式之一。但车辆、人员严重不足，配送起价较高、配送周期较长，影响市民采购。</p>
        <br>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_5.png" width="640">
      </p>
      <div class="tet-js">
        <p>“我们有菜，但是送不出去！”日前，美菜商城武汉公司向武汉市商务局反馈信息，与此同时，多家商超、电商企业纷纷提出同样需求。</p>
        <br>
        <p>武汉市商务局与市公交集团协商，由公交集团无偿支援500辆公交车，协助商超企业配送物资。其中，配给美菜商城45辆，单个企业最多。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_6.png" width="640">
      </p>
      <div class="tet-js">
        <p>2月25日清早，美菜商城武汉六仓联系上武汉公交集团江夏公司的27辆车。“听说要去各家各户送菜，大家都很积极，在群里踊跃报名。” 武汉公交集团江夏公司车队长王小平说，承接配送任务的公交车都进行了保养。</p>
        <br>
        <p>26日凌晨3点多，下着小雨，一溜8.5米长的公交车开进江夏区庙山大道的美菜商城武汉六仓，首批5辆公交车参与试运行，车辆全面消杀、司机穿戴防护装备。随后，工作人员赶紧将分拣好的蔬菜、大米、面粉、肉类、调料等依次搬上公交车。</p>
        <br>
        <p>分工明确，公交车司机只负责开车，美菜商城跟车人员负责装车、核货及“最后一公里”的配送。</p>
        <br>
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_7.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">一大早助力配送的5位公交司机师傅（蓝色雨衣）和车队的张队长</div>

      <div class="tet-js">
        <p>“怎么样，累不？”美菜商城配送员吴振国问公交司机晏贤新。“就是时间有点长，配送员是真辛苦。”晏贤新说，90多户居民的订单，每家差不多十几袋，跑上跑下，衣服湿了干、干了又湿，“到不了一线，在二线也可以的。”。</p>
        <br>
        <p>“送菜一年多了，坐公交送菜是头一回。”美菜商城配送员陈向阳给公交司机点赞，他说，公交车运量大，配送范围也大，客户比较分散，司机师傅们不仅负责开车，一直帮忙搬货。晚上7点多，陈向阳一行结束一天的配送，开始返程。</p>
        <br>
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_8.png" width="640">
      </p>
      <div class="tet-js" style="text-align: center">
        左：晏班长和六仓美鲜送司机陈向阳
        右：晏班长拍摄的陈向阳配送画面
      </div>

      <div class="tet-js">
        <p>此前，因配送能力有限，美菜商城只能在武汉各售卖区轮流开放。“今天开始，逐步全城开放，接收订单。”美菜商城武汉公司负责人说，有了公交车帮忙，公司将降低起送价、延长下单时间，方便更多市民及时买菜。</p>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
